var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201.7 201.7",
    style: {
      minWidth: 50
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #10547c;\n            }\n\n            .cls-2 {\n                fill: none;\n                stroke: #10547c;\n                stroke-miterlimit: 10;\n                stroke-width: 8px;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.54,
    y: 33.54,
    width: 134.62,
    height: 134.62,
    transform: "translate(100.85 -41.77) rotate(45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.36,51.67c-1.74-1.74-4.57-1.74-6.31,0l-42.74,42.81-32.58-32.54-10.23-10.21c-1.74-1.74-4.57-1.74-6.31,0-1.74,1.74-1.74,4.57,0,6.31l10.23,10.21,32.58,32.54-42.74,42.81c-1.74,1.74-1.74,4.57,0,6.31.88.86,2.01,1.31,3.15,1.31s2.29-.43,3.15-1.31l42.74-42.81,28.98,28.93,13.83,13.81c.88.86,2.01,1.31,3.15,1.31s2.29-.43,3.15-1.31c1.74-1.74,1.74-4.57,0-6.31l-13.83-13.81-28.98-28.93,42.74-42.81c1.74-1.74,1.74-4.57,0-6.31h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons01);
export default __webpack_public_path__ + "static/media/icons-01.6184acc8ea205f98688ef3d9a086f661.svg";
export { ForwardRef as ReactComponent };